export default {
  title: '选择扫码模板',
  empty: '暂无模板数据',
  searchPlaceholder: '请输入模板名称搜索',
};
